import { v4 as uuid } from "uuid";
import { AikaDate } from "utils/AikaDate";
import { ScheduleBlockDto } from "@aika/types";
import { MIN_BLOCK } from "./utils";

export class ScheduleBlock {
  id: string;
  description: string;
  start: number;
  length: number;
  color: number;
  date: AikaDate;
  tags: string[];
  isDeleted: boolean;

  private constructor() {
    this.id = uuid();
    this.description = "";
    this.start = 0;
    this.length = MIN_BLOCK;
    this.color = 0;
    this.date = AikaDate.today();
    this.tags = [];
    this.isDeleted = false;
  }

  asDto(): ScheduleBlockDto {
    return {
      id: this.id,
      description: this.description,
      start: this.start,
      length: this.length,
      color: this.color,
      date: this.date.toString(),
      tags: [...this.tags],
      isDeleted: this.isDeleted,
    };
  }

  covers(other: ScheduleBlock) {
    if (other == null) return false;

    return this.start < other.start && this.end > other.end;
  }

  isOnDay(day: AikaDate) {
    return this.date.equals(day);
  }

  get end() {
    return this.start + this.length;
  }

  set end(value) {
    this.length = Math.max(MIN_BLOCK, value - this.start);
  }

  clone() {
    return ScheduleBlock.fromDto(this.asDto());
  }

  static createNew(
    description: string,
    start: number,
    color: number,
    date: AikaDate,
    tags: string[]
  ) {
    const block = new ScheduleBlock();
    block.description = description;
    block.start = start;
    block.color = color;
    block.date = date;
    block.tags = tags;
    return block;
  }

  static fromDto(dto: ScheduleBlockDto) {
    const block = new ScheduleBlock();

    block.id = dto.id;
    block.description = dto.description;
    block.start = dto.start;
    block.length = dto.length;
    block.color = dto.color;
    block.date = AikaDate.fromDateString(dto.date);
    block.tags = [...dto.tags];
    block.isDeleted = dto.isDeleted ?? false;

    return block;
  }
}
